module.exports = __webpack_public_path__ + "static/media/dropshipping.cd2504a7.png";